document.addEventListener("DOMContentLoaded", function () {
  const messageDiv = document.getElementById("signup-message");

  // Check for success parameter in URL
  const urlParams = new URLSearchParams(window.location.search);
  const newsletter = urlParams.get("newsletter");

  if (newsletter === "success" && messageDiv) {
    // Only show hero message if not redirected to footer
    if (window.location.hash !== "#footer") {
      showMessage("Thank you! We'll be in touch soon.", "success");
    }

    // Remove the parameter from URL without page reload
    const newUrl = window.location.pathname + window.location.hash;
    window.history.replaceState({}, document.title, newUrl);
  }

  function showMessage(text, type) {
    messageDiv.textContent = text;
    messageDiv.className = `tmrw-form-message tmrw-form-message--${type}`;
    messageDiv.style.display = "block";
  }
});
